export function isNumber(predictable: unknown): predictable is number {
  return typeof predictable === 'number';
}
